<template>
  <div>
    <v-row no-gutters class="mb-2" v-if="xconceptos.length > 0">
      <v-col cols="12" class="pb-0 mt-0">
        <button
          :disabled="$store.state.isonlyread"
          class="btn btn-sm btn-link"
          @click="tableToExcel('table', 'Lorem Table')">
          <span class="glyphicon glyphicon-print"></span> Descargar en formato EXCEL_
        </button>
        <p class="mb-0 blue--text"><b>Seleccione los conceptos para ver la asignacion.</b></p>

        <!-- <p class="my-0 text-left green--text">fecha Inicio del programa: {{ fecha_inicio }}</p>
        <p class="my-0 text-left green--text">fecha finalizacion del programa: {{ fecha_fin }}</p> -->
      </v-col>
      <v-col cols="2" v-for="(c, ind) in xconceptos" :key="ind">
        <v-checkbox
          class="pt-0 mt-0"
          v-model="xconcetoschecks"
          :label="c.concepto"
          :value="c.concepto_pago_id"
          :color="ind % 2 == 0 ? '#7A3674' : '#1F6E43'"
          hide-details
          dense></v-checkbox>
      </v-col>
      <v-col cols="4">
        <v-switch
          v-model="hide_ceros"
          :label="hide_ceros ? 'Mostrar todo' : 'Ocultar filas vacias'"
          :disabled="xconceptos.length == 0 || xconcetoschecks.length > 1"
          dense
          hide-details
          title="Mostrar datos de la fila."
          class="mb-0 pt-0 mt-0"></v-switch>
      </v-col>
    </v-row>

    <div v-if="xconceptos.length > 0">
      <div class="d-flex justify-center">
        <p class="mb-0 pt-3 blue--text">Leyenda de colores:</p>
        <v-chip class="ma-2" label :color="parseInsColor(0)"> Pre inscrito </v-chip>
        <v-chip class="ma-2" label :color="parseInsColor(2)"> retirado </v-chip>
        <v-chip class="ma-2" label :color="parseInsColor(3)"> cambiado </v-chip>
        <v-chip class="ma-2" label :color="parseInsColor(4)"> congelado </v-chip>
        <v-chip class="ma-2" label :color="parseInsColor(5)"> pagado </v-chip>
      </div>
      <p class="text-left mb-0">
        <b>[{{ xprograma.codigo }}] {{ xprograma.nombre_compuesto }}</b>
      </p>

      <v-simple-table dense ref="table" :height="xalto">
        <template v-slot:default>
          <thead style="position: sticky; top: 0; z-index: 1">
            <tr>
              <th :key="'k-3'" class="fixedheader"></th>
              <template v-for="(k, ind2) in xconceptos">
                <th v-if="isconceptosel(k)" :key="'k-1' + ind2" :style="getcolor(ind2)"></th>
                <th
                  v-if="isconceptosel(k)"
                  :key="'k0' + ind2"
                  :style="getcolor(ind2)"
                  class="text-center"
                  :colspan="colspanconcepto()">
                  {{ k.concepto }}
                </th>
              </template>
            </tr>
            <tr>
              <th :key="'k-5'" class="fixedheader"></th>
              <template v-for="(k, ind2) in xconceptos">
                <th
                  v-if="isconceptosel(k)"
                  :key="'k-2' + ind2"
                  :style="getcolor(ind2)"
                  style="border-right: 1px solid #000000"
                  rowspan="2">
                  Total {{ k.concepto }}
                </th>
                <th
                  v-if="isconceptosel(k)"
                  :key="'kzx-2' + ind2"
                  :style="getcolor(ind2)"
                  style="border-right: 1px solid #000000"
                  rowspan="2">
                  Total Asignacion
                </th>
                <th
                  v-if="isconceptosel(k) && show_retrasado"
                  :key="'ks0' + ind2"
                  :style="getcolor(ind2)"
                  class="text-center"
                  colspan="4"
                  style="border-right: 1px solid #000000">
                  Retrasado
                </th>
                <th
                  v-if="isconceptosel(k) && show_recuperar"
                  :key="'ks1' + ind2"
                  :style="getcolor(ind2)"
                  class="text-center"
                  colspan="4"
                  style="border-right: 1px solid #000000">
                  Por recuperar
                </th>
                <th
                  v-if="isconceptosel(k)"
                  :key="'ks2' + ind2"
                  :style="getcolor(ind2)"
                  class="text-center"
                  colspan="4"
                  style="border-right: 1px solid #000000">
                  Vigente
                </th>
                <th
                  v-if="isconceptosel(k)"
                  :key="'k-1' + ind2"
                  :style="getcolor(ind2)"
                  class="text-center"
                  colspan="2"
                  style="border-right: 1px solid #000000">
                  Adelantado
                </th>
              </template>
            </tr>
            <tr>
              <th class="text-left white--text fixedheader" style="min-width: 250px">Estudiantes</th>
              <template v-for="(k, ind2) in xconceptos">
                <th
                  v-if="isconceptosel(k) && show_retrasado"
                  :key="'k1' + ind2"
                  :style="getcolor(ind2)"
                  class="text-left">
                  Cuota retrasada
                </th>
                <th
                  v-if="isconceptosel(k) && show_retrasado"
                  :key="'k2' + ind2"
                  :style="getcolor(ind2)"
                  class="text-left">
                  Nro cuota
                </th>
                <th
                  v-if="isconceptosel(k) && show_retrasado"
                  :key="'kt2' + ind2"
                  :style="getcolor(ind2)"
                  class="text-left">
                  Importe cobrado
                </th>
                <th
                  v-if="isconceptosel(k) && show_retrasado"
                  :key="'k3' + ind2"
                  :style="getcolor(ind2)"
                  class="text-left"
                  style="border-right: 1px solid #000000">
                  Saldo por cobrar
                </th>
                <th
                  v-if="isconceptosel(k) && show_recuperar"
                  :key="'k4' + ind2"
                  :style="getcolor(ind2)"
                  class="text-left">
                  Cuota por recuperar
                </th>
                <th
                  v-if="isconceptosel(k) && show_recuperar"
                  :key="'k5x' + ind2"
                  :style="getcolor(ind2)"
                  class="text-left">
                  Nro cuota
                </th>
                <th
                  v-if="isconceptosel(k) && show_recuperar"
                  :key="'k5' + ind2"
                  :style="getcolor(ind2)"
                  class="text-left">
                  Importe cobrado
                </th>
                <th
                  v-if="isconceptosel(k) && show_recuperar"
                  :key="'k6' + ind2"
                  :style="getcolor(ind2)"
                  class="text-left"
                  style="border-right: 1px solid #000000">
                  Saldo por cobrar
                </th>
                <th v-if="isconceptosel(k)" :key="'k7' + ind2" :style="getcolor(ind2)" class="text-left">
                  Cuota vigente
                </th>
                <th v-if="isconceptosel(k)" :key="'k8' + ind2" :style="getcolor(ind2)" class="text-left">Nro cuota</th>
                <th v-if="isconceptosel(k)" :key="'k48' + ind2" :style="getcolor(ind2)" class="text-left">
                  Importe Cobrado
                </th>
                <th
                  v-if="isconceptosel(k)"
                  :key="'k9' + ind2"
                  :style="getcolor(ind2)"
                  class="text-left"
                  style="border-right: 1px solid #000000">
                  Saldo por cobrar
                </th>
                <th v-if="isconceptosel(k)" :key="'g10' + ind2" :style="getcolor(ind2)" class="text-left">Nro cuota</th>
                <th v-if="isconceptosel(k)" :key="'k1j0' + ind2" :style="getcolor(ind2)" class="text-left">Importe</th>
              </template>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, ind) in xprogramas" :key="ind" :style="'background:' + parseInsColor(item.estado_ins)">
              <!-- <td>{{ item.nombre_completo }}</td> -->
              <td v-if="ismostrarFilaEstudiante(item)">
                <v-hover v-slot="{ hover }" open-delay="100">
                  <div>
                    <span> <b>{{ind+1}}.-</b> {{ item.nombre_completo }}<v-chip class="ma-2"
                        :color="getColorPlan(item.plan_pagos)" text-color="white" x-small>
                        {{ item.plan_pagos }}
                      </v-chip> </span>
                    <v-expand-transition>
                      <div
                        v-if="hover"
                        class="d-flex transition-fast-in-fast-out green darken-4 v-card--reveal white--text"
                        style="height: 100%; width: 90%">
                        <v-icon small @click="showMoreDetails(item)" title="Ver detalles" color="white" class="mr-4"
                          >mdi-eye</v-icon
                        >
                        <v-icon small @click="vermovimientos(item)" title="Ver movimientos" color="white" class="mr-4"
                          >mdi-calendar-search</v-icon
                        >
                        <v-icon
                          v-if="hover && item.estado_ins == 1"
                          small
                          @click="editarplanpagos(item)"
                          title="Editar plan de pagos"
                          color="white"
                          class="mr-4"
                          >mdi-clipboard-edit-outline</v-icon
                        >
                        <v-icon
                          v-if="
                            ($store.state.CARGO.id == 1 ||
                              $store.state.CARGO.id == 15 ||
                              $store.state.CARGO.id == 25 ||
                              $store.state.CARGO.id == 14) &&
                            hover
                          "
                          small
                          @click="cambiarestadomoodle(item)"
                          title="Cambiar estado"
                          color="white"
                          class="mr-4"
                          >mdi-account-key-outline</v-icon
                        >
                      </div>
                    </v-expand-transition>
                    <v-progress-linear v-if="item.loading" indeterminate color="white"></v-progress-linear>
                  </div>
                </v-hover>
              </td>
              <template v-for="(k, ind2) in item.detalle_asignacion">
                <td
                  v-if="(!hide_ceros || !hide_ceros === k.xadd) && isconceptosel(k)"
                  class="text-right"
                  :key="'1ind' + ind2">
                  {{ parsecomas(k.total_por_cobrar) }}
                </td>
                <td
                  v-if="(!hide_ceros || !hide_ceros === k.xadd) && isconceptosel(k)"
                  class="text-right"
                  :key="'cx1ind' + ind2">
                  {{ parsecomas(k.total_asignacion) }}
                </td>
                <td
                  v-if="(!hide_ceros || !hide_ceros === k.xadd) && isconceptosel(k) && show_retrasado"
                  class="text-right"
                  :key="'7ind' + ind2">
                  {{ parsecomas(k.retrasado) }}
                </td>
                <td
                  v-if="(!hide_ceros || !hide_ceros === k.xadd) && isconceptosel(k) && show_retrasado"
                  class="text-right"
                  :key="'3ind' + ind2">
                  {{ k.cuotas_retrasadas }}
                </td>
                <td
                  v-if="(!hide_ceros || !hide_ceros === k.xadd) && isconceptosel(k) && show_retrasado"
                  class="text-right"
                  :key="'30ind' + ind2">
                  {{ parsecomas(k.pagado_retrasado) }}
                </td>
                <td
                  v-if="(!hide_ceros || !hide_ceros === k.xadd) && isconceptosel(k) && show_retrasado"
                  class="text-right"
                  :key="'9ind' + ind2">
                  {{ parsecomas(k.saldo_retrasado) }}
                </td>
                <td
                  v-if="(!hide_ceros || !hide_ceros === k.xadd) && isconceptosel(k) && show_recuperar"
                  class="text-right"
                  :key="'6ind' + ind2">
                  {{ parsecomas(k.por_recuperar) }}
                </td>
                <td
                  v-if="(!hide_ceros || !hide_ceros === k.xadd) && isconceptosel(k) && show_recuperar"
                  class="text-right"
                  :key="'29ind' + ind2">
                  {{ k.cuotas_por_recuperar }}
                </td>
                <td
                  v-if="(!hide_ceros || !hide_ceros === k.xadd) && isconceptosel(k) && show_recuperar"
                  class="text-right"
                  :key="'2rind' + ind2">
                  {{ parsecomas(k.pagado_por_recuperar) }}
                </td>
                <td
                  v-if="(!hide_ceros || !hide_ceros === k.xadd) && isconceptosel(k) && show_recuperar"
                  class="text-right"
                  :key="'8ind' + ind2">
                  {{ parsecomas(k.saldo_por_recuperar) }}
                </td>
                <td
                  v-if="(!hide_ceros || !hide_ceros === k.xadd) && isconceptosel(k)"
                  class="text-right"
                  :key="'11ind' + ind2">
                  {{ parsecomas(k.vigente) }}
                </td>
                <td
                  v-if="(!hide_ceros || !hide_ceros === k.xadd) && isconceptosel(k)"
                  class="text-right"
                  :key="'4ind' + ind2">
                  {{ k.cuotas_vigentes }}
                </td>
                <td
                  v-if="(!hide_ceros || !hide_ceros === k.xadd) && isconceptosel(k)"
                  class="text-right"
                  :key="'100ind' + ind2">
                  {{ parsecomas(k.pagado_vigente) }}
                </td>
                <td
                  v-if="(!hide_ceros || !hide_ceros === k.xadd) && isconceptosel(k)"
                  class="text-right"
                  :key="'10ind' + ind2">
                  {{ parsecomas(k.saldo_vigente) }}
                </td>
                <td
                  v-if="(!hide_ceros || !hide_ceros === k.xadd) && isconceptosel(k)"
                  class="text-right"
                  :key="'5find' + ind2">
                  {{ k.cuotas_adelantadas }}
                </td>
                <td
                  v-if="(!hide_ceros || !hide_ceros === k.xadd) && isconceptosel(k)"
                  class="text-right"
                  :key="'5gind' + ind2">
                  {{ parsecomas(k.pago_adelantado) }}
                </td>
              </template>
            </tr>
            <tr style="background: #1f6e43; color: white">
              <td style="background: #1f6e43; color: white">Total</td>
              <template v-for="(k, ind2) in totales">
                <td v-if="isconceptosel(k)" class="text-right" :key="'1ind' + ind2">
                  {{ parsecomas(k.total_por_cobrar) }}
                </td>
                <td v-if="isconceptosel(k)" class="text-right" :key="'z1ind' + ind2">
                  {{ parsecomas(k.total_asignacion) }}
                </td>
                <td v-if="isconceptosel(k) && show_retrasado" class="text-right" :key="'7ind' + ind2">
                  {{ parsecomas(k.retrasado) }}
                </td>
                <td v-if="isconceptosel(k) && show_retrasado" class="text-right" :key="'3ihnd' + ind2"></td>
                <td v-if="isconceptosel(k) && show_retrasado" class="text-right" :key="'3iund' + ind2">
                  {{ parsecomas(k.pagado_retrasado) }}
                </td>
                <td v-if="isconceptosel(k) && show_retrasado" class="text-right" :key="'9ind' + ind2">
                  {{ parsecomas(k.saldo_retrasado) }}
                </td>
                <td v-if="isconceptosel(k) && show_recuperar" class="text-right" :key="'6ind' + ind2">
                  {{ parsecomas(k.por_recuperar) }}
                </td>
                <td v-if="isconceptosel(k) && show_recuperar" class="text-right" :key="'24rind' + ind2"></td>
                <td v-if="isconceptosel(k) && show_recuperar" class="text-right" :key="'2rrind' + ind2">
                  {{ parsecomas(k.pagado_por_recuperar) }}
                </td>
                <td v-if="isconceptosel(k) && show_recuperar" class="text-right" :key="'8ind' + ind2">
                  {{ parsecomas(k.saldo_por_recuperar) }}
                </td>
                <td v-if="isconceptosel(k)" class="text-right" :key="'11ind' + ind2">{{ parsecomas(k.vigente) }}</td>
                <td v-if="isconceptosel(k)" class="text-right" :key="'4ind' + ind2"></td>
                <td v-if="isconceptosel(k)" class="text-right" :key="'a10ind' + ind2">
                  {{ parsecomas(k.pagado_vigente) }}
                </td>
                <td v-if="isconceptosel(k)" class="text-right" :key="'b10ind' + ind2">
                  {{ parsecomas(k.saldo_vigente) }}
                </td>
                <td v-if="isconceptosel(k)" class="text-right" :key="'v5ind' + ind2">
                  {{ parsecomas(k.cuotas_adelantadas) }}
                </td>
                <td v-if="isconceptosel(k)" class="text-right" :key="'5ind' + ind2">
                  {{ parsecomas(k.pago_adelantado) }}
                </td>
              </template>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <p class="text-center green--text">
      {{ msg }}
    </p>

    <plan-pagos-details ref="refPlaPagosDetail" />
    <AMovimientos ref="refmovimientos" />
    <AMoodleEstadoV2 ref="refmoodleestado" />
  </div>
</template>

<style scoped>
  table tbody td:first-child {
    position: sticky;
    left: 0;
    background: #efefef;
    z-index: 0;
    text-align: left;
  }
  .fixedheader {
    position: sticky;
    left: 0;
    background: #196391;
    z-index: 1;
    text-align: left;
  }
  .xtable,
  tr,
  td {
    border: 1px solid #444;
  }

  .xtable td:last-child {
    border: 2px solid black;
  }

  tbody td:nth-child(2) {
    color: #000000;
  }
  .v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: 1;
    position: absolute;
    width: 100%;
  }
</style>

<script>
  import PlanPagosDetails from '@/views/Inscripcion/PlanPagosDetails';
  import AMovimientos from '@/components/AMovimientos';
  import AMoodleEstadoV2 from '@/components/AMoodleEstadoV2';
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        // EXCEL
        uri: 'data:application/vnd.ms-excel;base64,',
        template:
          '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head> <meta charset="utf-8"> <!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
        base64: function (s) {
          return window.btoa(unescape(encodeURIComponent(s)));
        },
        format: function (s, c) {
          return s.replace(/{(\w+)}/g, function (m, p) {
            return c[p];
          });
        },
        // END EXCEL
        msg: '',
        xconceptos: [],
        xprogramas: [],
        xconcetoschecks: [],
        totales: [],
        hide_ceros: false,
        show_retrasado: true,
        show_recuperar: true,
        xprograma: '',
        xalto: 700,
      };
    },
    watch: {
      xconcetoschecks: {
        deep: true,
        handler() {
          this.hide_ceros = false;
        },
      },
      'screen.width': function () {
        this.getalto();
      },
    },
    components: { PlanPagosDetails, AMovimientos, AMoodleEstadoV2 },
    computed: {},
    methods: {
      tableToExcel(table, name) {
        if (this.xconcetoschecks.length == 0) {
          this.$root.$notify.show(`Debe seleccionar al menos 1 concepto`, { color: 'danger', x: 'left' });
          return;
        }
        if (!table.nodeType) table = this.$refs.table;
        var ctx = { worksheet: name || 'Worksheet', table: table.$el.childNodes[0].childNodes[0].innerHTML };
        var link = document.createElement('a');
        link.download = 'REPORTE_ASIGNACION_POR_PROGRAMA_MKT.xls';
        link.href = this.uri + this.base64(this.format(this.template, ctx));
        link.click();
      },
      getColorPlan(plan) {
      if (/cr[eé]dito/i.test(plan)) {
        return 'secondary';
      } else if (plan.toLowerCase().includes('contado')) {
        return 'primary';
      }
      return '';
    },
      getcolor(i) {
        if (i % 2 == 0) return 'background:#7A3674;color:white';
        else return 'background:#1F6E43;color:white';
      },
      parseInsColor(ins) {
        if (ins == 0) return '#D1DBA4';
        else if (ins == 1) return '#ffffff';
        else if (ins == 2) return '#FFA8B1';
        else if (ins == 3) return '#FFE0A8';
        else if (ins == 4) return '#A8D3FF';
        else if (ins == 5) return '#FFA8F2';
        else return '';
      },
      isconceptosel(k) {
        return this.xconcetoschecks.includes(k.concepto_pago_id);
      },
      ismostrarFilaEstudiante(item) {
        let idsel = this.xconcetoschecks[0];
        let k = item.detalle_asignacion.find((x) => x.concepto_pago_id == idsel);
        if (k) return !this.hide_ceros || !this.hide_ceros === k.xadd;
        return true;
      },
      colspanconcepto() {
        let tam = 7;
        if (this.show_retrasado) tam += 4;
        if (this.show_recuperar) tam += 4;
        return tam;
      },
      irsumando(c, key) {
        if (typeof c[key] != 'number') return; // solo suma numeros
        if (key == 'concepto_pago_id') return; // omitir este campo
        //window.console.log(c.concepto_pago_id, key);

        let existe = this.totales.find((x) => {
          return x.concepto_pago_id == c.concepto_pago_id;
        });
        if (!existe) {
          let ex = {};
          ex.concepto_pago_id = c.concepto_pago_id;
          ex[key] = c[key];
          this.totales.push(ex);
        } else {
          if (existe[key] != null) {
            existe[key] += c[key];
          } else {
            existe[key] = c[key];
          }
        }
      },
      parsecomas(str) {
        try {
          if (!str) str = 0;
          let number = window.accounting.formatMoney(str, '', 2, '.', ',');
          return number;
        } catch (e) {
          window.console.error(e);
          return str;
        }
      },
      toggleColumna() {
        if (!this.fecha_fin) return;
        let t1 = new Date(this.fecha_consulta);
        let t2 = new Date(this.fecha_fin);
        window.console.log(this.fecha_consulta, '--------', this.fecha_fin);
        window.console.log(t1, '--------', t2);

        if (t1.getTime() >= t2.getTime()) {
          this.show_recuperar = true;
          this.show_retrasado = false;
        } else {
          this.show_recuperar = false;
          this.show_retrasado = true;
        }

        /*let date = new Date(this.fecha_fin);
        let ahora = new Date();
        ahora.setDate(1);
        window.console.log(ahora, date); 
        if (date.getTime() < ahora.getTime()) {
          this.show_recuperar = true;
          this.show_retrasado = false;
        } else {
          this.show_recuperar = false;
          this.show_retrasado = true;
        }*/
      },
      showMoreDetails(estud) {
        estud.loading = true;
        const vue = this;
        const url = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/${estud.inscripcion_id}/plan-pago`;
        xaxios.get(url).then(({ data }) => {
          vue.$refs.refPlaPagosDetail.showThisView(data.data, estud.idestudiante, estud.inscripcion_id);
          estud.loading = false;
        });
      },
      vermovimientos(est) {
        est.nombres = est.nombre_completo;
        let ins = {};
        ins.id = est.inscripcion_id;
        ins.estudiante = est;
        this.$refs.refmovimientos.open(ins);
      },
      editarplanpagos(est) {
        this.$router.push({
          name: 'editarplanpagos',
          params: { idprograma: this.xprograma.id, idpersona: est.idestudiante, idinscripcion: est.inscripcion_id },
        });
      },
      cambiarestadomoodle(est) {
        this.$refs.refmoodleestado.openmodal(this.xprograma.id, est.idestudiante, est.inscripcion_id, this.plataforma);
      },
      obtenerasignaciones(gestion, mes, programa, tipoasignacion, plataforma, nro_cuota = 1, fecha = '', desde = true) {
        //obtenerasignaciones(convenio, nro_cuota = 1, fecha = '', desde = true) {
        //let sede_id = this.$store.state.CARGO.sede.id;
        this.plataforma = plataforma;
        this.tipoasignacion = tipoasignacion;
        this.gestion = gestion;
        this.fecha_fin = programa.fecha_fin;
        this.fecha_inicio = programa.fecha_inicio;
        this.fecha_consulta = fecha;
        this.xprograma = programa;
        this.mes = mes;

        const vue = this;
        this.xconceptos = [];
        this.xprogramas = [];
        this.xconcetoschecks = [];
        this.totales = [];
        let urla = `${process.env.VUE_APP_API_REST}/api/v3/esam/asignacion/cobranza/programas?fecha=${fecha} 23:59&programa_id=${programa.id}&nro_cuota=${nro_cuota}&desde=${desde}`;
        const promise2 = xaxios.get(urla);

        Promise.all([promise2])
          .then(function (values) {
            let data1 = values[0];
            if (data1.data == '') data1.data = { data: [] };
            if (!data1.data) data1.data = { data: [] };
            if (!data1.data.data) data1.data.data = [];
            let datos = data1.data.data;
            datos.forEach((x) => {
              x.loading = false; // custom para las opciones hover
              x.detalle_asignacion.forEach((d) => {
                let con = vue.xconceptos.find((cc) => cc.concepto_pago_id == d.concepto_pago_id);
                if (!con) vue.xconceptos.push(d);
              });
            });
            vue.xconceptos.sort((a, b) => {
              return a.concepto_pago_id - b.concepto_pago_id;
            });
            vue.xconceptos.forEach((c) => {
              datos.forEach((x) => {
                let tieneasig = x.detalle_asignacion.find((da) => da.concepto_pago_id == c.concepto_pago_id);
                if (!tieneasig) {
                  let xdefault = {
                    concepto_pago_id: c.concepto_pago_id,
                    concepto: c.concepto,
                    total_cuotas: 1,
                    total_por_cobrar: 0,
                    total_asignacion: 0,
                    retrasado: 0,
                    cuotas_retrasadas: '',
                    pagado_retrasado: 0,
                    saldo_retrasado: 0,
                    por_recuperar: 0,
                    cuotas_por_recuperar: null,
                    pagado_por_recuperar: 0,
                    saldo_por_recuperar: 0,
                    vigente: 0,
                    cuotas_vigentes: null,
                    pagado_vigente: 0,
                    saldo_vigente: 0,
                    pago_adelantado: 0,
                    cuotas_adelantadas: null,
                    xshow: true,
                    xadd: true,
                  };
                  x.detalle_asignacion.push(xdefault);
                } else {
                  tieneasig.xshow = true;
                  tieneasig.xadd = false;
                }
                x.detalle_asignacion.sort((a, b) => {
                  return a.concepto_pago_id - b.concepto_pago_id;
                });
              });
            });

            datos.sort((a, b) => {
              return a.nombre_completo.localeCompare(b.nombre_completo);
            });

            datos.forEach((x) => {
              x.detalle_asignacion.forEach((d) => {
                Object.keys(d).forEach((xc) => {
                  vue.irsumando(d, xc);
                });
              });
            });
            //window.console.log(JSON.stringify(datos, null, 2));
            vue.toggleColumna();
            vue.xprogramas = datos;

            vue.$emit('dataloaded');
          })
          .catch((e) => {
            window.console.error(e);
            vue.$emit('dataloaded');
            vue.loading = false;
            if (e.response.status == 403) {
              vue.xmsg = 'Vuelva a acceder al sistema, su session ha caducado.';
            } else if (e.response.status == 500) {
              vue.xmsg =
                '(500) Actualmente estamos teniendo inconvientes al obtener los datos, lamentamos las molestias causadas :)';
            }
            vue.$emit('dataloaded');
          });
      },
      getalto() {
        this.xalto = screen.height - 300;
      },
    },
    mounted() {
      this.getalto();
    },
  };
</script>
